import React from "react";
import {XMarkIcon} from "@heroicons/react/20/solid";
import Button from "../../../../common/components/button";

const COLUMNS = {
    tire: [
        {key: 'pos', labelKey: 'field.dot_wheel_position'},
        {key: 'tread', labelKey: 'field.dot_tread_32nds'},
        {key: 'psi', labelKey: 'field.dot_psi'}
    ],
    brake: [
        {key: 'pos', labelKey: 'field.dot_wheel_end'},
        {key: 'stroke', labelKey: 'field.dot_brake_stroke'},
        {key: 'pad', labelKey: 'field.dot_brake_pad'}
    ]
};

export default function DotInspectionMeasurementTable({type, rows, onRowChange, onAddRow, onRemoveRow, translate}) {
    const columns = COLUMNS[type];

    return (
        <div className="mt-3 space-y-2">
            <div className="overflow-x-auto">
                <table className="min-w-full text-sm border-collapse">
                    <thead>
                        <tr>
                            {columns.map((col) => (
                                <th
                                    key={col.key}
                                    className="text-left font-semibold text-tm-gray-700 pb-2 pr-4 border-b border-tm-gray-300"
                                >
                                    {translate(col.labelKey)}
                                </th>
                            ))}

                            <th className="border-b border-tm-gray-300"/>
                        </tr>
                    </thead>

                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={row._uid} className="border-t border-tm-gray-200">
                                {columns.map((col) => (
                                    <td key={col.key} className="py-1.5 pr-4">
                                        <input
                                            type="text"
                                            value={row[col.key]}
                                            onChange={(e) => onRowChange(index, col.key, e.target.value)}
                                            className="w-24 rounded-input border border-tm-gray-300 bg-inverse text-tm-gray-900 px-2 py-1 text-sm focus:outline-hidden focus:border-primary"
                                        />
                                    </td>
                                ))}

                                <td className="py-1.5">
                                    <button
                                        type="button"
                                        onClick={() => onRemoveRow(index)}
                                        className="text-tm-gray-400 hover:text-red-600"
                                    >
                                        <XMarkIcon className="w-4 h-4"/>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Button appearance="muted" onClick={onAddRow}>
                {translate(type === 'tire' ? 'btn.dot_add_tire_position' : 'btn.dot_add_wheel_end')}
            </Button>
        </div>
    );
}
